import { FC } from 'react';
import styled, { DefaultTheme } from 'styled-components';
import { getInitials, getAvatarColor } from '../../services/Player';

export interface IAvatar {
  name: string;
  className?: string;
  small?: boolean;
}

type ContainerProps = {
  avatarColor: string;
  theme: DefaultTheme;
  small?: boolean;
};

const Container = styled.div(({ avatarColor, small, theme }: ContainerProps) => {
  const { color, type } = theme;

  return `
    border-radius: 50%;
    background-color: ${avatarColor};
    color: ${color.grayscale[1000]};
    font-size: ${type.size.regular};
    font-weight: ${type.weight.bold};
    font-family: ${type.face};
    height: ${small ? '1.875rem' : '3rem'};
    width: ${small ? '1.875rem' : '3rem'};
    min-width: ${small ? '1.875rem' : '3rem'};
    display: inline-flex;
    flex-flow; row nowrap;
    justify-content: center;
    align-items: center;
    line-height: ${type.size.larger};
  `;
});

const Avatar: FC<IAvatar> = ({ name, className, small }) => {
  const initials = getInitials(name);

  return (
    <Container className={className} avatarColor={getAvatarColor(initials)} small={small}>
      {getInitials(name)}
    </Container>
  );
};

export default Avatar;
